import { useEffect, type FC } from 'react';
import { useNavigate } from 'react-router';

import LoadingOverlay from '@/components/LoadingOverlay';
import { ProfileService } from '@/services';

const SplashPage: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const targetPath = ProfileService.isLoggedIn()
      ? '/profile/home'
      : '/profile/phone';

    navigate(targetPath, { replace: true });
  }, [navigate]);

  return <LoadingOverlay isVisible={true} />;
};

export default SplashPage;
